import { useEffect, useState } from "react";
import { fetchUserDetails } from "../../apis/user.api";

// Permissions are now fully server-resolved. The frontend holds no role matrix and
// no catalogue data — it only asks the backend "what is this user's effective set?"
// (role matrix ∪ granted − revoked, computed server-side) and checks membership.
export type PermissionName = string;

export const usePermissions = () => {
  const [perms, setPerms] = useState<Set<string> | null>(null);

  useEffect(() => {
    fetchUserDetails()
      .then((res) => {
        const eff =
          res?.effective_permissions ?? res?.branch?.effective_permissions ?? [];
        setPerms(new Set(Array.isArray(eff) ? eff : []));
      })
      .catch(() => setPerms(new Set()));
  }, []);

  const loaded = perms !== null;
  const hasPermission = (permission_name: PermissionName) =>
    !!perms?.has(permission_name as string);

  return { hasPermission, loaded };
};
